import { BpAnchor } from '../../../../shared/components/text/anchor/BpAnchor'
import React from 'react'

interface ScreenshotCellProps {
  link_screen_url: string
}

export const ScreenshotCell = ({ link_screen_url }: ScreenshotCellProps) => {
  return (
    <BpAnchor href={link_screen_url} target='_blank'>
      Screenshot
    </BpAnchor>
  )
}
